var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKurdish({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1759_1205)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H24V5.33333H0V0Z",
    fill: "#E64C3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.33325H24V10.6666H0V5.33325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.6667H24V16.0001H0V10.6667Z",
    fill: "#29A85E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7703 11.5579L12.5799 9.88429L12.6372 11.9149L11.993 9.96478L11.4492 11.9221L11.4084 9.8687L10.3119 11.5788L10.8782 9.60459L9.32628 10.9155L10.4493 9.19591L8.57996 9.99114L10.1599 8.67898L8.13927 8.88789L10.0358 8.09972L8.04334 7.70375L10.0879 7.50961L8.30069 6.54394L10.3117 6.96109L8.88848 5.51151L10.6872 6.50288L9.75446 4.69821L11.181 6.17571L10.8217 4.1763L11.7494 6.00864L11.9954 3.99214L12.3417 6.01652L13.1712 4.16211L12.9055 6.19865L14.2446 4.6711L13.3904 6.53885L15.1204 5.47389L13.7536 7.00688L15.7206 6.49914L13.9627 7.56117L15.9919 7.65575L13.9991 8.15245L15.9103 8.84097L13.8596 8.7282L15.483 9.94946L13.5566 9.23725L14.7479 10.8828L13.117 9.63438L13.7703 11.5579Z",
    fill: "#FCD116"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1759_1205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKurdish);
export default __webpack_public_path__ + "static/media/kurdish.e4f527d9aecf7e4e815d52f73b35ecde.svg";
export { ForwardRef as ReactComponent };